import { useCallback, useRef } from 'react';
import { useMeasure, useWindowSize } from 'react-use';

export const useMaxItemContainerWidth = (
  optOut?: boolean,
): {
  ref: (element: HTMLElement | null) => void;
  maxWidth: number | '100%' | 'none';
} => {
  const { width: windowWidth } = useWindowSize();
  const elementRef = useRef<HTMLElement | null>(null);
  const [measureRef] = useMeasure<HTMLElement>();

  const ref = useCallback(
    (element: HTMLElement | null): void => {
      elementRef.current = element;
      if (element) {
        measureRef(element);
      }
    },
    [measureRef],
  );

  if (optOut) {
    return { ref, maxWidth: '100%' };
  }

  // useMeasure triggers re-renders on element resize via ResizeObserver.
  // We read viewport-relative left via getBoundingClientRect during render,
  // which is re-evaluated whenever useMeasure or useWindowSize causes a re-render.
  const left = elementRef.current?.getBoundingClientRect().left;
  const maxWidth = left ? (windowWidth || 2000) - left - 20 : undefined;

  return { ref, maxWidth: maxWidth ? Math.round(maxWidth) : 'none' };
};
